import type { ReactNode } from 'react';

export interface PageHeadProps {
  readonly title: ReactNode;
  readonly subtitle?: ReactNode;
  readonly crumb?: ReactNode;
  readonly actions?: ReactNode;
}

export function PageHead({ title, subtitle, crumb, actions }: PageHeadProps): JSX.Element {
  return (
    <header className="adm-page-head">
      <div>
        {crumb ? <div className="crumb">{crumb}</div> : null}
        <h1>{title}</h1>
        {subtitle ? <p className="sub">{subtitle}</p> : null}
      </div>
      {actions ? <div className="actions">{actions}</div> : null}
    </header>
  );
}
